import { createAsyncThunk } from '@reduxjs/toolkit';
import * as olppApi from '../../../api/olpp';
import * as ccpApi from '../../../api/ccp';
import * as poppApi from '../../../api/popp';

export const handleCcpPaymentCreate = createAsyncThunk(
  'userApplication/ccpPayCreate',
  async (payload) => {
    const apiResponse = await ccpApi.ccpPayCreate(payload);
    return apiResponse?.data?.data;
  }
);

export const handlePoppPaymentCreate = createAsyncThunk(
  'adminApplication/poppPayCreate',
  async (payload) => {
    const apiResponse = await poppApi.poppPayCreate(payload);
    return apiResponse?.data?.data;
  }
);

export const handleOlppPaymentCreate = createAsyncThunk(
  'userApplication/olppPayCreate',
  async (payload) => {
    const apiResponse = await olppApi.olppPayCreate(payload);
    return apiResponse?.data?.data;
  }
);